import React, { Component } from "react";
import moment from "moment";

import SelectBox from "../../../../../../components/select-box/select-box";
import CalendarBox from "../../../../../../components/calendar-box/calendar-box";
import DicotomicButton from "../../../../../../components/dicotomic-button";
import InputBox from "../../../../../../components/input-box/input-box";
import SearchBox from "../../../../../../components/search-box-mediadores/search-box";
import { PersonalInformationContainer } from "./taker-personal-information-style";

import { withGeneral } from "../../../../../../context/mixin/with-general";
import { deepGet } from "../../../../../../utils/utility";
import { filterCountries, getCountriesList } from "../../../../../../utils/countries";
import { calcAge, checkDate } from "../../../../../../utils/utility";
import {
  genderOptions,
  getSelfEmployedDocumentTypes,
  isValidCif,
  isValidDocumentID,
  validateSelfEmployedDocType,
  validateStandarisedFieldsHealthHiring,
} from "../../../../../../utils/validation";
import {
  DefaultPersonalData,
  DefaultValueFormHealth,
  PersonalDataDto,
} from "./taker-personal-information-dto";
import {
  PersonalData,
  PersonalInformationProps,
  PersonalInformationState,
} from "./taker-personal-information-types";
import { DOC_NUMBER_MAX_LENGTH } from "../../../../../../constants";

class PersonalInformation extends Component<PersonalInformationProps, PersonalInformationState> {
  _searchWaiter: any = null;

  constructor(props: PersonalInformationProps) {
    super(props);

    this.state = {
      person: this.getPersonalDataDto(props.taker),
      stateDisabled: props.isReadOnly ? props.isReadOnly : false,
      countries: [],
      countriesFiltered: [],
    };
  }

  getPersonalDataDto(personData?: PersonalData, disabled: boolean = false): PersonalDataDto {
    const countries = this.state && this.state.countries;
    const country =
      personData &&
      personData.nationality &&
      countries &&
      countries.length > 0 &&
      countries.find((country) => country.value === personData.nationality);

    const newPerson =
      !personData || Object.keys(personData).length === 0
        ? DefaultPersonalData()
        : {
            name: this.getValueFormHealth(personData.name, disabled),
            lastName1: this.getValueFormHealth(personData.lastname1, disabled),
            lastName2: this.getValueFormHealth(personData.lastname2, disabled),
            birthDate: this.getValueFormHealth(
              personData.birthDate ? checkDate(personData.birthDate) : "",
              disabled
            ),
            docType: this.getValueFormHealth(personData.docType, disabled),
            docNumber:
              calcAge(moment(personData.birthDate).format("DD/MM/YYYY")) > 16 &&
              personData.docType === "MENOR"
                ? this.getValueFormHealth("", disabled)
                : this.getValueFormHealth(personData.docNumber, disabled),
            sex: this.getValueFormHealth(personData.gender, disabled),
            nationality: {
              value: personData.nationalityLabel
                ? personData.nationalityLabel
                : country
                ? country.label
                : "",
              errorCode: "",
              disabled: disabled,
              code: personData.nationality ? personData.nationality : country ? country.value : "",
            },
            nationalityLabel: personData.nationalityLabel
              ? personData.nationalityLabel
              : country
              ? country.value
              : "",
            passportDate: this.getValueFormHealth(
              personData.passportDate ? personData.passportDate : "",
              disabled
            ),
            physicalPerson:
              personData.physicalPerson !== undefined
                ? personData.physicalPerson
                : this.props.physicalPersonValue
                ? this.props.physicalPersonValue
                : true,
            tc2: this.getValueFormHealth(personData.tc2, disabled),
            reta: this.getValueFormHealth(personData.reta, disabled),
            responsable: this.getValueFormHealth(personData.responsable, disabled),
          };

    return newPerson;
  }

  getValueFormHealth(value: string | undefined, disabled: boolean) {
    return {
      value: value ? value : "",
      errorCode: "",
      disabled: disabled,
      code: "",
    };
  }

  componentWillReceiveProps(nextProps: PersonalInformationProps) {
    let { validate } = this.props;

    if (nextProps.validate.validateRequest) {
      validate.validateRequest = false;
      validate.isValidated = this.validateForm();
    } else if (nextProps.onCleanForm) {
      this.cleanForm();
    }
  }

  async componentDidMount() {
    const countries = await getCountriesList(this.props.countries, this.props.setLoading);
    countries.map((country: any) => (country.label = country.label.toUpperCase()));

    this.setState({ countries });
  }

  async handleValueChange(input: string, value: any) {
    let { person } = this.state;
    const { taker } = this.props;
    if (
      !(input === "sex" && taker && value === taker.gender) &&
      !(input === "docType" && taker && value === taker.docType)
    ) {
      this.props.onAnyChange();
    }

    switch (input) {
      case "name":
      case "lastName1":
      case "lastName2":
      case "birthDate":
      case "docNumber":
      case "sex":
      case "docType":
      case "passportDate":
      case "tc2":
      case "reta":
      case "responsable":
        value = typeof value === "string" ? value.toUpperCase() : value;
        Object.keys(person).forEach((k: string) => {
          if (k === input) {
            person[k].errorCode = "";
            person[k].value = value;

            const isOnChangeEvent = true;
            validateStandarisedFieldsHealthHiring(value, input, isOnChangeEvent, person);
          }
        });
        break;

      case "nationality":
        person.nationality.value = value.label;
        person.nationality.code = value.value;
        person.nationality.errorCode = "";
        person.nationalityLabel = value.label;
        if (value.value !== "ESPA" && person.lastName2.errorCode === "required") {
          person.lastName2.errorCode = "";
        }
        break;

      default:
        break;
    }

    this.setState({ person });
  }

  validateForm(): boolean {
    let { person } = this.state;
    let noErrors = true;

    if (person.physicalPerson) {
      Object.keys(person).forEach((key) => {
        const value = (person as any)[key] ? (person as any)[key].value : "";
        const isOnChangeEvent = false;
        let validation = validateStandarisedFieldsHealthHiring(value, key, isOnChangeEvent, person);
        if (key === "docType") {
          validation = validateSelfEmployedDocType({
            docType: person.docType.value,
            nationality: person.nationality.value,
            required: true,
          });
          person[key] = {
            ...person[key],
            errorCode: validation.errorCode,
          }; 
        }
        if (validation && validation.isError) noErrors = false;
      });

      if (person.nationality.value.length === 0) {
        person.nationality.errorCode = "required";
        noErrors = false;
      }

      if (person.docNumber.value.length === 0) {
        person.docNumber.errorCode = "required";
        noErrors = false;
      } else if (!isValidDocumentID(person.docNumber.value, person.docType.value)) {
        if (person.docNumber.value.length > 0) {
          person.docNumber.errorCode = "invalid-document-dni";
          noErrors = false;
        }
        if (
          person.docType.value === "NIF" &&
          person.docNumber.value.length === 9
        ) {
          person.docNumber.errorCode = "invalid-document-dni";
          noErrors = false;
        } else {
          person.docNumber.errorCode = "invalid-format";
          noErrors = false;
        }
      }

      if (person.sex.value.length === 0) {
        person.sex.errorCode = "required";
        noErrors = false;
      }
      if (person.docType.value.length === 0) {
        person.docType.errorCode = "required";
        noErrors = false;
      }
      if (person.docType.value === "PAS" && person.passportDate.value.length === 0) {
        person.passportDate.errorCode = "required";
        noErrors = false;
      }
    } else {
      if (!person.name.value) {
        person.name.errorCode = "required";
        noErrors = false;
      } else if (!isValidCif(person.docNumber.value)) {
        person.docNumber.errorCode = "invalid-format";
        noErrors = false;
      }
      if (!person.docNumber.value) {
        person.docNumber.errorCode = "required";
        noErrors = false;
      }
      if (!person.responsable.value) {
        person.responsable.errorCode = "required";
        noErrors = false;
      }
    }

    if (noErrors) {
      if (this.props.onValidated) {
        if (person.physicalPerson) {
          this.props.onValidated({
            name: person.name.value,
            lastname1: person.lastName1.value,
            lastname2: person.lastName2.value,
            birthDate: person.birthDate.value,
            docType: person.docType.value,
            docNumber: person.docNumber.value,
            passportDate: person.passportDate.value,
            gender: person.sex.value,
            nationality:
              typeof person.nationality.code === "string"
                ? person.nationality.code
                : deepGet(person, "nationality.code.code", ""),
            nationalityLabel: person.nationality.value,
            physicalPerson: person.physicalPerson,
            tc2: person.tc2.value,
            reta: person.reta.value,
            responsable: person.responsable.value,
          });
        } else {
          this.props.onValidated({
            name: person.name.value,
            docNumber: person.docNumber.value,
            lastname1: "",
            lastname2: "",
            birthDate: new Date().toLocaleDateString(),
            docType: "CIF",
            passportDate: undefined,
            gender: "",
            nationality: "",
            nationalityLabel: "",
            physicalPerson: false,
            tc2: person.tc2.value,
            reta: person.reta.value,
            responsable: person.responsable.value,
          });
        }
      }
    }

    this.setState({ person });
    return noErrors;
  }

  cleanForm() {
    this.setState({
      person: DefaultPersonalData(),
      stateDisabled: false,
      countriesFiltered: this.state.countries,
    });
  }

  changeValueSearchBox(ev: any, arg1: string, arg2: string) {
    if (this._searchWaiter) {
      clearInterval(this._searchWaiter);
    }
    const { person } = this.state;
    const value: string = ev.target.value;

    // Reset searchBox values to default if delete prev data
    if (value.length < 1) {
      if (this.state.person.hasOwnProperty(arg2) && arg2 === "nationality") {
        person.nationality = DefaultValueFormHealth();
        person.nationalityLabel = "";
      }
      this.setState({ person });
    }

    if (value.length < 2) return;

    if (value.length >= 2) {
      switch (arg2) {
        case "nationality":
          this.setState({
            countriesFiltered: filterCountries(value, this.state.countries),
          });
          break;

        default:
          break;
      }
    }
  }

  render() {
    const { person, countriesFiltered } = this.state;
    const { isReadOnly } = this.props;

    return (
      <PersonalInformationContainer>
        <div className="content-wrapper bottomMargin20" ref={""}>
          <div className="personal-data-wrapper">
            <div className="data-title" id="data-personal">
              <h5>DATOS PERSONALES</h5>
            </div>

            <div className="receip-radio-main-row">
              <div className={isReadOnly ? "radioBox disabled" : "radioBox"}>
                <label>
                  <input
                    type="radio"
                    disabled={isReadOnly}
                    name="person"
                    value={"personal"}
                    onChange={() => {
                      const { person } = this.state;
                      this.props.handlePersonChange("physical");
                      person.lastName1.value =
                        person.lastName1.value === undefined ? "" : person.lastName1.value;
                      person.physicalPerson = true;
                      this.setState({ person });
                    }}
                    checked={person.physicalPerson}
                  />
                  <span>PERSONA FÍSICA</span>
                </label>
              </div>
              <div className={isReadOnly ? "radioBox disabled" : "radioBox"}>
                <label>
                  <input
                    type="radio"
                    name="person"
                    value={"legal"}
                    onChange={() => {
                      this.props.handlePersonChange("legal");
                      person.physicalPerson = false;
                      this.setState({ person });
                    }}
                    checked={!person.physicalPerson}
                    disabled={isReadOnly}
                  />
                  <span>PERSONA JURÍDICA</span>
                </label>
              </div>
            </div>

            {person.physicalPerson ? (
              <div className="personal-data-fisica">
                <div className="personal-data-row">
                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <InputBox
                        placeholder="Nombre"
                        required={true}
                        errorCode={person.name.errorCode}
                        disabled={person.name.disabled || isReadOnly}
                        value={person.name.value}
                        onChange={(value: string) => this.handleValueChange("name", value)}
                      />
                    </div>
                  </div>

                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <InputBox
                        placeholder="Apellido 1"
                        required={true}
                        errorCode={person.lastName1.errorCode}
                        disabled={person.lastName1.disabled || isReadOnly}
                        value={person.lastName1.value}
                        onChange={(value: string) => this.handleValueChange("lastName1", value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="personal-data-row">
                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <InputBox
                        placeholder="Apellido 2"
                        required={person.nationality && person.nationality.code === "ESPA"}
                        errorCode={person.lastName2.errorCode}
                        disabled={person.lastName2.disabled || isReadOnly}
                        value={person.lastName2.value}
                        onChange={(value: string) => this.handleValueChange("lastName2", value)}
                      />
                    </div>
                  </div>

                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <CalendarBox
                        initialValue={person.birthDate.value}
                        placeholder="Fecha de nacimiento"
                        forbidFutureDates
                        minAge={18}
                        maxDate={moment().toISOString()}
                        required={true}
                        disabled={person.birthDate.disabled || isReadOnly}
                        errorCode={person.birthDate.errorCode}
                        onChange={(value: string) => this.handleValueChange("birthDate", value)}
                        health={true}
                      />
                    </div>
                  </div>
                </div>

                <div className="personal-data-row">
                  <div className="personal-data-item col-50">
                    <div className="personal-data-item col-25">
                      <DicotomicButton
                        required={true}
                        labelText="Sexo"
                        options={genderOptions}
                        withTab={true}
                        disabled={person.sex.disabled || isReadOnly}
                        initialValue={person.sex.value}
                        onChange={(value: string) => this.handleValueChange("sex", value)}
                        errorCode={person.sex.errorCode}
                      />
                    </div>
                  </div>
                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <SearchBox
                        onChange={(ev: any) =>
                          this.changeValueSearchBox(ev, "contact", "nationality")
                        }
                        labelText=""
                        optionsText={countriesFiltered}
                        optionKey={"value"}
                        optionValue={"label"}
                        disabled={person.nationality.disabled || isReadOnly}
                        initialValue={person.nationality.value}
                        required={true}
                        errorCode={person.nationality.errorCode}
                        onSelect={(value: any) => this.handleValueChange("nationality", value)}
                      />
                      <label>Nacionalidad</label>
                    </div>
                  </div>
                </div>

                <div className="personal-data-container">
                  <div className="personal-data-row">
                    <div className="personal-data-item col-50">
                      <div className="selectBox">
                        <SelectBox
                          placeholder="Documento de identidad"
                          required={true}
                          errorCode={person.docType.errorCode}
                          optionsText={getSelfEmployedDocumentTypes({ nationality: person.nationality.value })}
                          optionKey={"value"}
                          optionValue={"label"}
                          initialValue={person.docType.value}
                          defaultValue={person.docType.value}
                          disabled={person.docType.disabled || isReadOnly}
                          onChange={(value: string) => this.handleValueChange("docType", value)}
                        />
                        <label>{"Documento de identidad"}</label>
                      </div>
                    </div>
                    <div className="personal-data-item col-50">
                      <div className="inputBox">
                        <InputBox
                          placeholder="Nº de documento"
                          required
                          errorCode={person.docNumber.errorCode}
                          maxLength={DOC_NUMBER_MAX_LENGTH}
                          value={person.docNumber.value}
                          onChange={(value: string) => this.handleValueChange("docNumber", value)}
                          type={
                            person.docType.value === "NIF"
                              ? "NIF"
                              : person.docType.value === "NIE"
                              ? "NIE"
                              : "NIF"
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="personal-data-juridica">
                <div className="personal-data-row">
                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <InputBox
                        placeholder="Razón Social"
                        required={true}
                        errorCode={person.name.errorCode}
                        disabled={person.name.disabled || isReadOnly}
                        value={person.name.value}
                        onChange={(value: string) => this.handleValueChange("name", value)}
                        type={"numbersletter"}
                      />
                    </div>
                  </div>

                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <InputBox
                        placeholder="CIF"
                        required={true}
                        errorCode={person.docNumber.errorCode}
                        disabled={person.docNumber.disabled || isReadOnly}
                        value={person.docNumber.value}
                        onChange={(value: string) => this.handleValueChange("docNumber", value)}
                        type={"text"}
                        maxLength={DOC_NUMBER_MAX_LENGTH}
                      />
                    </div>
                  </div>
                </div>

                <div className="personal-data-row">
                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <InputBox
                        errorCode={person.responsable.errorCode}
                        onChange={(value: string) => this.handleValueChange("responsable", value)}
                        placeholder="RESPONSABLE"
                        required
                        disabled={person.responsable.disabled || isReadOnly}
                        type={"letters"}
                        value={person.responsable.value}
                      />
                    </div>
                  </div>

                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <InputBox
                        onChange={(value: string) => this.handleValueChange("tc2", value)}
                        placeholder="T.C.2"
                        type={"text"}
                        disabled={person.tc2.disabled || isReadOnly}
                        value={person.tc2.value}
                      />
                    </div>
                  </div>
                  <div className="personal-data-item col-50">
                    <div className="inputBox">
                      <InputBox
                        onChange={(value: string) => this.handleValueChange("reta", value)}
                        placeholder="R.E.T.A"
                        type={"text"}
                        disabled={person.reta.disabled || isReadOnly}
                        value={person.reta.value}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </PersonalInformationContainer>
    );
  }
}

export default withGeneral(PersonalInformation);
